export enum GendersList {
  MALE = "male",
  FEMALE="female",
  TRANSGENDER="transgender"
}
  